<template>
    <div v-if="!loading && !error">
        <div class="container" id="case-study-offset" v-if="categoriesSorted" >
            <div class="case-studies__categories"> 
                <div class="case-studies__categories-inner" v-for="category in categoriesSorted" :key="category.url"> 
                    <div @click="handleCategoryClick(section)" v-for="section in category" :key="section.url" class="case-studies__category-link" :class="{
                        'case-studies__category-link--active': section.url === content.url,
                    }">
                        {{ section.title }}
                    </div>
                </div>
            </div>
            <div class="case-studies__categories-dropdown"> 
                <div class="news-block__cards-filter">
                    <select @change="handleCategorySelect">
                        <option v-for="category in categories" :key="category.title" >{{ category.title }}</option>
                    </select>
                    <i class="icon-chevron-down"></i>
                </div>
            </div>
            <!-- <div v-if="content" class="case-studies__cards-title">{{ content.title }}</div> -->
       </div>
       <hr>
       <div class="swiper__container">
        <div ref="caseStudies" v-if="content" class="container case-studies__cards" :class="{
            'case-studies__cards--navigation': content.articles && content.articles.length > 1
        }"> 
                <swiper 
                    id="case-studies-slider"
                    :modules="modules"
                    :space-between="gutter"
                    @swiper="onSwiper"
                    @slideChange="onSlideChange"
                    :slidesOffsetAfter="paddingRight"
                    :slidesOffsetBefore="paddingLeft"
                    :scrollbar="scrollbar"
                    :autoHeight="true"
                    :navigation="navigation"
                    :mousewheel="{
                        forceToAxis:true
                    }"
                    :breakpoints="breakpoints"
                >
                    <swiper-slide v-for="(slide, index) in content.articles" :key="index" class="case-studies__card" >
                        <div class="case-studies__title" v-html="slide.title"></div>
                        <a :href="slide.url + `?state=${encodeURIComponent(this.content.title)}`" class="case-studies__action">Read Full Case Study</a>
                    </swiper-slide>
                    <div class="card-carousel__legend">
                        <div class="card-carousel__legend-bar"></div>
                    </div>
                </swiper>
            </div>
            <button v-if="content.articles && content.articles.length > 1" class="case-studies__swiper-prev swiper__button swiper__button--prev" type="button"><span>Prev</span></button>
            <button v-if="content.articles && content.articles.length > 1"  class="case-studies__swiper-next swiper__button swiper__button--next" type="button"><span>Next</span></button>
       </div>
    </div>
</template>

<script>
import axios from 'axios';
import { Mousewheel, Navigation, Scrollbar, Manipulation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css/bundle';

export default {
    props: ["categoryId"],
    data() {
        return {
            error: false,
            loading: true,
            categories: [],
            content: [],
            gutter: 16,
            paddingLeft: 0,
            paddingRight: 0,
        }
    },
    mounted() {
        let self = this;
        this.getCaseStudies();
        self.setSidePadding();
        window.addEventListener("resize", function () {
            self.setSidePadding();
        });
    },
    components: {
        Swiper,
        SwiperSlide,
    },
    computed: {
        categoriesSorted: function () {
            let groups = [];
            let columns = this.categories.reduce((group, category, index) => {
                let groupIndex = Math.ceil((index + 1) / 6) - 1;
                group[groupIndex] = group[groupIndex] ?? [];
                group[groupIndex].push(category);
                return group;
            }, {});

                groups.push(columns[0])
                groups.push(columns[1])
                groups.push(columns[2])
            return groups;
        }
    },
    methods: {
        setSidePadding: function () {
            // spacing
            if (window.innerWidth >= 960) {
                this.paddingLeft = 0;
                this.paddingRight = 0;
            } else {
                this.paddingLeft = 16;
                this.paddingRight = 16;
            }
        },
        handleStateParam: function () {
             const urlParams = new URLSearchParams(window.location.search);
            const stateParam = urlParams.get('state');

            let category = this.categories.filter((c) => {
                return c.title === stateParam;
            });

            if (category && category.length > 0) {
                this.handleCategoryClick(category[0]);
            }
        },
        handleCategoryClick: function (category) {
            this.content = category;
        },  
        handleCategorySelect: function (e) {
            let content = this.categories.filter((category) => {
                return category.title === e.target.value;
            });


            this.content = content[0];

            var element = this.$refs.caseStudies;
            var headerOffset = 80;
            var elementPosition = element.getBoundingClientRect().top;
            var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth',
            });
        }, 
        getCaseStudies: function () {
            axios.post("/api/case-studies/" + this.categoryId, {
                tags: this.tags
            }, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            })
                .then((response) => {
                    this.categories = response.data.categories
                    this.content = this.categories[0];
                    this.loading = false;
                    this.handleStateParam();
                })
                .catch((err) => {
                    this.error = true;
                    this.loading = false;
                });
        }
    },
    setup() {
        const onSwiper = (swiper) => {
        };
        const onSlideChange = (swiper) => {
        };
        return {
            onSwiper,
            onSlideChange,
            scrollbar: {
                el: '.card-carousel__legend',
                draggable: true,
                dragClass: 'card-carousel__legend-bar'
            },
            updateOnWindowResize: true,
            watchSlidesProgress: true,
            allowTouchMove: true,
            draggable: true,
            zoom: false,
            snapIndex: 1,
            snapOnRelease: false,
            watchOverflow: true,
            navigation: {
                nextEl: ".case-studies__swiper-next",
                prevEl: ".case-studies__swiper-prev",
            },
            breakpoints: {
                320: {
                    slidesPerView: 1.1
                },
                768: {
                    slidesPerView: 2.1,
                },
                960: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 2,
                },
                1200: {
                    slidesPerView: 3,
                },
                1440: {
                    slidesPerView: 3,
                },
            },
            modules: [Navigation, Scrollbar, Mousewheel, Manipulation],
        };
    },
}
</script>

